module.exports = __webpack_public_path__ + "img/Glycine_max.f08e9882.jpg";